<template>
    <div>
        <q-input 
        outlined 
        label="Basis Recommendation" 
        v-model="StoreStateCD.BasisRecommendation"
        :rules="[ val=> val!=='' && val!==null ]"
        />
    </div>
</template>

<script>
import store from '../store'
import { mapState, mapActions } from "vuex";

export default {
    name: 'BasisRecommendation',
    data() {
        return {
            StoreStateCD : store.state.CD,
        }
    },
    methods: {
        
    }
}
</script>